<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_POSTS"
    :breadcrumbs="breadcrumbs"
    page-name="Manage Stories"
    align="left"
    width="full"
  >
    <iRow wrap="nowrap" align="between">
      <iColumn width="hug">
        <iHeading>Manage Stories</iHeading>
      </iColumn>
      <iColumn width="hug">
        <iButton
          variant="secondary"
          :is-loading="isLoadingCreateStory"
          width="hug"
          @click="createNewStory()"
        >
          Create Story
        </iButton>
      </iColumn>
    </iRow>
    <SmartFeed
      :pinia-store="useMyPublicationPostFeedStore"
      default-smart-feed-layout="table"
      default-entity-layout="tableRow"
      sticky-headers
      vertical-align="middle"
    >
      <template #empty-state>
        <iText variant="subtle">
          No stories found.
        </iText>
      </template>
    </SmartFeed>
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
</template>

<script>
import PageWrapper from "@/components/PageWrapper";
import {
  PAGE_PUBLICATION_POSTS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import { mapActions, mapState, mapWritableState } from "pinia";
import SmartFeed from "SmartFeed/components/SmartFeed";
import { useMyPublicationPostFeedStore } from "SmartFeed/stores/feed/my-publication-post-feed-store";
import { useStoryStore } from "%/stores/story-store";
import { useStoryEngagementFeedStore } from "SmartFeed/stores/feed/story-engagement-feed-store";
import { useCollaboratorStore } from "@/stores/collaborator-store";
import { STORY_VARIANT_TYPE_STORY } from "@/constants/story-variant-type-constants";
import { PUBLISHING_PLATFORM_TYPE } from "%/constants/story-constants";

export default {
  name: "ViewPublicationPostList",
  components: { SmartFeed, PageWrapper },
  data() {
    return {
      PAGE_PUBLICATION_POSTS,
      SECTION_PUBLICATIONS,
      postExclusivityLoading: null,
      dropdownOpenFor: null,
    };
  },
  computed: {
    ...mapWritableState(useCreatorPublicationStore, [
      "orgId",
      "publication",
      "publicationId",
    ]),
    ...mapState(useStoryStore, ["isLoadingCreateStory"]),
    ...mapState(useCollaboratorStore, [
      "canView",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        {
          url: `/publication/${this.publicationId}`,
          label: this.publication.name,
        },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
  methods: {
    useStoryEngagementFeedStore,
    useMyPublicationPostFeedStore,
    ...mapActions(useStoryStore, [
      "createStory",
    ]),
    createNewStory() {
      this.createStory({
        publishing_platform_id: this.publicationId,
        publishing_platform_type: PUBLISHING_PLATFORM_TYPE.PUBLICATION,
        variant_type: STORY_VARIANT_TYPE_STORY,
      });
    },
  },
};
</script>

<style scoped lang="scss">
</style>
